import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import Refresh_btn from "../../../../../common/common_btn/refresh_btn/Refresh_btn";
import {
  Create,
  GetAll,
} from "../../../../../features/admin/role_permmission/role/Slice";
import { useDispatch, useSelector } from "react-redux";
import { AllPermmission } from "../../../../../features/admin/common/Slice";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const Add_Role = ({
  show,
  handleClose,
  // setShowError,
  // showError,
  setShow,
  setErr,
  setSuccess,
}) => {
  const dispatch = useDispatch();
  const [showError, setShowError] = useState("");
  const permissions = useSelector((state) => state.common.all_permission);

  // console.log("permissionspermissions", permissions);

  useEffect(() => {
    dispatch(AllPermmission());
  }, [dispatch]);

  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const handlePermissionChange = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    setShowError("");
    if (selectedPermissions.length === permissions.length) {
      // untick all
      setSelectedPermissions([]);
    } else {
      // tick all
      const allIds = permissions.map((perm) => perm.id);
      setSelectedPermissions(allIds);
    }
  };

  const onSubmit = async (data) => {
    try {
      console.log(
        selectedPermissions,
        "selectedPermissions selectedPermissions",
      );

      if (!selectedPermissions || selectedPermissions.length === 0) {
        setShowError("Please select at least one permission");
        return; // Stop submission
      }

      const sendData = new FormData();

      sendData.append("name", data.name);
      sendData.append("description", data.description || "");
      sendData.append("status", data.status);

      // send permissions array
      selectedPermissions.forEach((id) => {
        sendData.append("permission_id[]", id);
      });

      const res = await dispatch(Create(sendData));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setSuccess(true);
        handleClose();

        setTimeout(() => {
          setSuccess(false);
        }, 3000);
      } else if (res.meta?.requestStatus === "rejected") {
        setShowError(res.payload?.response?.data?.errors);
      }
    } catch (error) {
      // setErr(true);
      console.error(error);
    }
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (show) {
      // Clear form fields
      reset({
        name: "",
        description: "",
        status: "",
        created_by: "",
        created_date: "",
      });

      // Clear permissions
      setSelectedPermissions([]);

      // Refill auto fields
      const token = Cookies.get("ultimate_analytics_admin_security");

      if (token) {
        const decoded = jwtDecode(token);
        setValue("created_by", decoded.name || decoded.unique_id);

        const today = new Date().toISOString().split("T")[0];
        setValue("created_date", today);
      }
    }
  }, [show]);

  const [showMap, setShowMap] = useState(false);
  const [hideForm, setHideForm] = useState(false);

  const [viewDoc, setViewDoc] = useState(false);

  const [activeTab, setActiveTab] = useState("basic");

  const documentSectionRef = useRef(null);
  const basiSectionRef = useRef(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "basic" && basiSectionRef.current) {
      basiSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }

    if (tab === "document" && documentSectionRef.current) {
      documentSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [searchName, setSearchName] = useState("");

  useEffect(() => {
    dispatch(AllPermmission({ name: searchName }));
  }, [dispatch, searchName]);
  return (
    <Offcanvas
      className="mobile_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Add New Role
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="add_form">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="white_container" ref={documentSectionRef}>
              <div className="common_form_div">
                <div className="row">
                  {/* Role Name */}
                  <div className="col-sm-12">
                    <Form.Group className="form_group">
                      <Form.Label>Role Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="eg. LAB MANAGER"
                        {...register("name", {
                          required: "Role name is required",
                        })}
                        isInvalid={!!errors.role_name}
                      />
                      {errors?.name && (
                        <Form.Text className="text-danger">
                          {errors?.name?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  {/* Role Description */}
                  <div className="col-sm-12">
                    <Form.Group className="form_group">
                      <Form.Label>Role Description (Optional)</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Type Description"
                        {...register("description")}
                      />
                    </Form.Group>
                  </div>

                  {/* Status */}
                  <div className="col-sm-6">
                    <Form.Group className="form_group">
                      <Form.Label>Current Status:</Form.Label>
                    </Form.Group>
                  </div>

                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="radio"
                        label="Active"
                        value="1"
                        className="green_text"
                        {...register("status", {
                          required: "Status is required",
                        })}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        label="Inactive"
                        value="0"
                        className="red_text"
                        {...register("status")}
                      />
                    </div>
                    <small className="text-danger">
                      {errors.status?.message}
                    </small>
                  </div>

                  {/* Created By */}
                  <div className="col-sm-6">
                    <Form.Group className="form_group">
                      <Form.Label>Created By (Auto Fetch)</Form.Label>
                      <Form.Control
                        type="text"
                        {...register("created_by")}
                        disabled
                      />
                    </Form.Group>
                  </div>

                  {/* Created Date */}
                  <div className="col-sm-6">
                    <Form.Group className="form_group">
                      <Form.Label>Created Date</Form.Label>
                      <Form.Control
                        type="date"
                        {...register("created_date")}
                        disabled
                      />
                    </Form.Group>
                  </div>

                  <div className="search_form_div">
                    <div className="col-sm-12">
                      <Form.Group
                        className="form_group"
                        controlId="formBasicName"
                      >
                        <Form.Label>Search Permission For Role:</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Permissions"
                          value={searchName}
                          onChange={(e) => setSearchName(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                  </div>

                  {/* Permissions */}
                  <div className="col-sm-12">
                    <Form.Group className="form_group">
                      <Form.Label className="text_decoration">
                        Permission Categories:
                      </Form.Label>
                    </Form.Group>
                  </div>
                  {showError && (
                    <div style={{ color: "red", marginTop: "5px" }}>
                      {showError}
                    </div>
                  )}
                  <div className="col-sm-12">
                    <div className="radio_holder">
                      <Form.Check
                        type="checkbox"
                        label="Select All"
                        checked={
                          permissions.length > 0 &&
                          selectedPermissions.length === permissions.length
                        }
                        onChange={handleSelectAll}
                      />
                    </div>
                  </div>

                  {permissions.map((perm) => (
                    <div className="col-sm-6" key={perm.id}>
                      <div className="radio_holder">
                        <Form.Check
                          type="checkbox"
                          label={perm.name}
                          checked={selectedPermissions.includes(perm.id)}
                          onChange={() => handlePermissionChange(perm.id)}
                        />
                      </div>
                    </div>
                  ))}

                  <div className="col-sm-12">
                    <small className="text-danger">
                      {errors.permissions?.message}
                    </small>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="offcanvas_footer_holder">
                {/* {!success ? (
                  <> */}
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                <Refresh_btn onClick={() => reset()} />
                {/* </>
                ) : (
                  <Success_Toster successText="Role Added Successfully!" />
                )} */}
              </div>
            </div>
          </Form>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Add_Role;
